
import { translations } from './translations';

type Language = 'fr' | 'en';

export const useTranslation = (language: Language = 'fr') => {
  const t = (key: string): string => {
    if (!translations[key]) {
      console.warn(`Translation key not found: ${key}`);
      return key;
    }
    return translations[key][language];
  };

  return { t };
};
